import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Anatomy from "../../Docs/Components/Table/TableAnatomy.mdx";
import Usage from "../../Docs/Components/Table/TableUsage.mdx";

import Examples from "../../Docs/Components/Table/TableExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Table"
            description="Table can be used to display a data set in an easy to scan way."
            apiSources={["azure-devops-ui/Components/Table/Table.Props.d.ts"]}
            styleDocGroups={["table"]}
            examples={Examples}
            status={{"design":"Revision soon","code":"done","docs":"done"}}
            anatomy={Anatomy}
            usage={Usage}
        />
    );
}
}
        
export default Page;